export class Currency {
    public static readonly Usd = 'USD';
    public static readonly Can = 'CAN';
}
